export default __webpack_public_path__ + "static/media/socialmedia.947e48a3.png";